import RenderCategoryItems from './RenderCategoryItems'
import RenderCategoryHeading from './RenderCategoryHeading'

function RenderCategories(props) {
  const { categoryName, categoryData, forPDF } = props

  return (
    categoryData.count > 0 ?
      <div key={categoryName}>
        {forPDF ? (
          <div className="mb-4 mb-xl-6">
            <RenderCategoryHeading categoryData={categoryData} forPDF={forPDF}></RenderCategoryHeading>
            <RenderCategoryItems categoryDataItems={categoryData.items} forPDF={forPDF}></RenderCategoryItems>
          </div>
        ) : (
          <div className="rounded-4 border border-1 mb-4 mb-xl-6">
            <RenderCategoryHeading categoryData={categoryData}></RenderCategoryHeading>
            <RenderCategoryItems categoryDataItems={categoryData.items} forPDF={forPDF}></RenderCategoryItems>
          </div>
        )}
      </div>
      : ''
  );
}

export default RenderCategories